import { render, staticRenderFns } from "./MoleculeAvailabilityFilterResultsContainer.vue?vue&type=template&id=035a2a9e&scoped=true&"
import script from "./MoleculeAvailabilityFilterResultsContainer.vue?vue&type=script&lang=js&"
export * from "./MoleculeAvailabilityFilterResultsContainer.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeAvailabilityFilterResultsContainer.vue?vue&type=style&index=0&id=035a2a9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a2a9e",
  null
  
)

/* custom blocks */
import block0 from "@/lang/MoleculeAvailabilityFilterResults.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fcomponents%2Fmolecules%2Fproject%2FbuildingV2%2FMoleculeAvailabilityFilterResultsContainer.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsAtomLoader: require('/app/components/atoms/AtomLoader.vue').default,MoleculesProjectBuildingV2MoleculeAvailabilityFilterResultsList: require('/app/components/molecules/project/buildingV2/MoleculeAvailabilityFilterResultsList.vue').default})
